<template>
  <div class="card">
    <div class="card-body">
      <div>
        <a-page-header :title="$t('menu.preinscription')">
          <template slot="extra"> </template>
          <a-descriptions size="small" :column="3">
            <a-descriptions-item :label="$t('menu.eleves')">
              {{ filtredTable.length }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('liste.parents')">
              {{ parentsCount }}
            </a-descriptions-item>
          </a-descriptions>
          <a-row type="flex">
            <a-statistic
              :title="$t('liste.total')"
              :value="filtredTable.length"
            />
            <a-statistic
              :title="$t('liste.filles')"
              prefix="%"
              :value="countFille"
              :style="{
                margin: '0 32px',
              }"
            />
            <a-statistic
              :title="$t('liste.garcons')"
              prefix="%"
              :value="countGarcon"
            />
          </a-row>
        </a-page-header>

        <a-table
          @change="tableChanged"
          :loading="tableLoading"
          :pagination="true"
          :data-source="data"
          :columns="columns"
          :rowKey="(record) => record._id + '_' + record.student._id"
        >
          <template slot="student" slot-scope="text, record">
            <template v-if="record.student">
              <a-avatar
                size="large"
                style="color: #f56a00; background-color: #fde3cf"
              >
                {{ record.student.firstName[0].toUpperCase() }}
              </a-avatar>
              <span class="ml-2">
                <template v-if="searchText && searchedColumn === 'student'">
                  <template
                    v-for="(fragment, i) in (
                      record.student.firstName +
                      (record.student.middleName ? ' ' + record.student.middleName : '') +
                      ' ' +
                      record.student.lastName
                    )
                      .toString()
                      .split(
                        new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                      )"
                  >
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight"
                      >{{ fragment }}</mark
                    >
                    <template v-else>{{ fragment }}</template>
                  </template>
                </template>
                <template v-else>
                  {{ record.student.firstName + (record.student.middleName ? " " + record.student.middleName : "") + " " + record.student.lastName }}
                </template>
              </span>
            </template>
          </template>

          <template slot="level" slot-scope="text, record">
            <a-tag
              :key="record.student.level"
              color="blue"
              v-if="record.student"
            >
              {{ levelLabes[record.student.level] }}
            </a-tag>
          </template>

          <template slot="createdAt" slot-scope="text, record">
            {{ moment(record.createdAt).format("YYYY/MM/DD HH:mm") }}
          </template>
          <template slot="updatedAt" slot-scope="text, record">
            {{ moment(record.updatedAt).format("YYYY/MM/DD HH:mm") }}
          </template>

          <template slot="ficheparent" slot-scope="text, record">
            <a-button @click="() => parentFile(record)">
              <a-icon type="select" /> {{ $t("action.afficher") }}
            </a-button>
          </template>

          <template slot="actions" slot-scope="text, record">
            <a-button-group>
              <a-popconfirm
                :title="$t('inscription.sureToInscri')"
                @confirm="() => onInscri(record)"
              >
                <a-button
                  type="primary"
                  size="small"
                  icon="user"
                  :loading="record.inscriptionLoading"
                  :disabled="record.inscriptionLoading"
                >
                  {{ $t("inscription.inscription") }}
                </a-button>
              </a-popconfirm>
              <a-popconfirm
                :title="$t('all.sureToCancelAlert')"
                @confirm="() => onDelete(record)"
              >
                <a-button type="danger" size="small" icon="delete">
                  {{ $t("action.supprimer") }}
                </a-button>
              </a-popconfirm>
            </a-button-group>
          </template>

          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="$t('paiement.chercher') + ` ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("inscription.rechercher") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
        </a-table>

        <a-modal
          v-model="visibleParentFile"
          :title="$t('all.enterInformationBelow')"
          :width="1000"
          :key="componentKey"
        >
          <a-form :form="parentsForm" @submit="updateParent">
            <!-- Father Information Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.nomPere") }} & {{ $t("liste.prenomPere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.nomPere')">
                  <a-input
                    v-decorator="[
                      'fatherFirstName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomPere'),
                          },
                          {
                            whitespace: true,
                            message: $t('requis.prenomPere'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.prenomPere')">
                  <a-input
                    v-decorator="[
                      'fatherLastName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomPere'),
                          },
                          {
                            whitespace: true,
                            message: $t('requis.nomPere'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('profil.middleName')">
                  <a-input
                    v-decorator="[
                      'fatherMiddleName',
                      {
                        rules: [
                          {
                            required: false,
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Mother Information Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.nomMere") }} & {{ $t("liste.prenomMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.nomMere')">
                  <a-input
                    v-decorator="[
                      'motherFirstName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.prenomMere'),
                          },
                          {
                            whitespace: true,
                            message: $t('requis.prenomMere'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.prenomMere')">
                  <a-input
                    v-decorator="[
                      'motherLastName',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.nomMere'),
                          },
                          {
                            whitespace: true,
                            message: $t('requis.nomMere'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('profil.middleName')">
                  <a-input
                    v-decorator="[
                      'motherMiddleName',
                      {
                        rules: [
                          {
                            required: false,
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Phone Numbers Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.telPere") }} & {{ $t("liste.telMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.telPere')">
                  <phone-number-input
                    :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
                    :disabled="!!activeParent.parentID"
                    v-decorator="[
                      'fatherPhone',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telPere'),
                          },
                        ],
                      },
                    ]"
                    @change="onFatherPhoneChange"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.telMere')">
                  <phone-number-input
                    :default-country-code="countryCode === 'KE' ? 'KE' : 'TN'"
                    :disabled="!!activeParent.parentID"
                    v-decorator="[
                      'motherPhone',
                      {
                        rules: [
                          {
                            required: true,
                            message: $t('requis.telMere'),
                          },
                        ],
                      },
                    ]"
                    @change="onMotherPhoneChange"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Job Information Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.metierPere") }} & {{ $t("liste.metierMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.metierPere')">
                  <a-input
                    v-decorator="[
                      'fatherJob',
                      {
                        rules: [
                          {
                            whitespace: true,
                            message: $t('requis.noWhitespace'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.metierMere')">
                  <a-input
                    v-decorator="[
                      'motherJob',
                      {
                        rules: [
                          {
                            whitespace: true,
                            message: $t('requis.noWhitespace'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- National ID (CIN) Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.cinPere") }} & {{ $t("liste.cinMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.cinPere')">
                  <a-input
                    :placeholder="$t('liste.cinPere')"
                    maxlength="8"
                    v-decorator="[
                      'fatherCin',
                      {
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.cinMere')">
                  <a-input
                    :placeholder="$t('liste.cinMere')"
                    maxlength="8"
                    v-decorator="[
                      'motherCin',
                      {
                        rules: [
                          {
                            validator: (rule, value, cb) => {
                              if (!value || String(value).trim() === '') return cb();
                              if (!/^[01]\d{7}$/.test(String(value).trim())) return cb(this.$t('requis.cin01'));
                              cb();
                            },
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Email Information Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.emailPere") }} & {{ $t("liste.emailMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.emailPere')">
                  <a-input
                    v-decorator="[
                      'fatherEmail',
                      {
                        rules: [
                          {
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.emailMere')">
                  <a-input
                    v-decorator="[
                      'motherEmail',
                      {
                        rules: [
                          {
                            type: 'email',
                            message: $t('requis.email'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Adress Information Section -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-primary mb-3">
                  {{ $t("liste.adressePere") }} & {{ $t("liste.adresseMere") }}
                </h6>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.adressePere')">
                  <a-input
                    v-decorator="[
                      'fatherAdress',
                      {
                        rules: [
                          {
                            whitespace: true,
                            message: $t('requis.adresse'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
              <div class="col-md-6 mb-3">
                <a-form-item :label="$t('liste.adresseMere')">
                  <a-input
                    v-decorator="[
                      'motherAdress',
                      {
                        rules: [
                          {
                            whitespace: true,
                            message: $t('requis.adresse'),
                          },
                        ],
                      },
                    ]"
                    :disabled="!!activeParent.parentID"
                  />
                </a-form-item>
              </div>
            </div>

            <!-- Students List Section -->
            <div class="row">
              <div class="col-12">
                <h6 class="text-primary mb-3">{{ $t("menu.eleves") }}</h6>
                <div class="card">
                  <div class="card-body p-3">
                    <a-list
                      :grid="{ gutter: 16, column: 3 }"
                      item-layout="v"
                      :data-source="activeStudentlist"
                      :bordered="false"
                    >
                      <a-list-item slot="renderItem" slot-scope="item, index">
                        <a-list-item-meta :description="item.description">
                          <a
                            slot="title"
                            :class="index"
                            class="text-decoration-none"
                            >{{ item.title }}</a
                          >
                          <a-avatar
                            size="large"
                            slot="avatar"
                            style="color: #f56a00; background-color: #fde3cf"
                          >
                            {{ item.title[0].toUpperCase() }}
                          </a-avatar>
                        </a-list-item-meta>
                      </a-list-item>
                    </a-list>
                  </div>
                </div>
              </div>
            </div>
          </a-form>

          <template slot="footer">
            <a-button
              key="back"
              @click="handleCancelModalParent"
              :disabled="loadingData"
            >
              {{ $t("action.annuler") }}
            </a-button>
            <a-button
              v-if="!activeParent.parentID"
              key="submit"
              type="primary"
              :loading="loadingData"
              :disabled="loadingData"
              @click="updateParent"
            >
              {{ $t("action.confirmer") }}
            </a-button>
          </template>
        </a-modal>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState } from "vuex";
import moment from "moment";
import { getAllLevels } from "@/config/LevelConstants";

export default {
  data() {
    return {
      parentsForm: this.$form.createForm(this),
      componentKey: 0,
      filtredTable: [],
      tableLoading: true,
      parentsList: [],
      activeParent: {
        parentID: "",
        father: {
          firstname: "",
          lastName: "",
          job: "",
          email: "",
          adress: "",
        },
        mother: {
          firstname: "",
          lastName: "",
          job: "",
          email: "",
          adress: "",
        },
        students: [
          {
            firstName: "",
            lastName: "",
            _id: "",
          },
        ],
      },
      activeStudentlist: [],
      visibleParentFile: false,
      data: [],
      loadingData: false,
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      // Add validation timeout for phone number checking
      phoneValidationTimeout: null,
    };
  },
  computed: {
    ...mapState(["settings", "user"]),
    activeBuilding() {
      return this.user.building.find(
        (el) => el.dbName == this.settings.activeBuilding
      );
    },
    countryCode() {
      return this.activeBuilding?.countryCode || "TN";
    },
    levelLabes() {
      const allLevels = getAllLevels(this.$t.bind(this), this.countryCode);

      const levelsObj = {};
      Object.entries(allLevels).forEach(([key, value]) => {
        const numKey = Number(key);
        levelsObj[numKey] = value;
        levelsObj[key] = value;
      });

      return levelsObj;
    },
    columns() {
      return [
        {
          title: this.$t("liste.nomPrenom"),
          dataIndex: "student",
          key: "student",
          scopedSlots: {
            customRender: "student",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          onFilter: (value, record) =>
            record.student.firstName
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            (record.student.middleName && record.student.middleName.toLowerCase().includes(value.toLowerCase())) ||
            record.student.lastName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: this.$t("personnel.niveau"),
          dataIndex: "level",
          key: "level",
          scopedSlots: {
            customRender: "level",
          },
          onFilter: (value, record) => record.student.level.includes(value),
        },
        {
          title: this.$t("library.createdAt"),
          dataIndex: "createdAt",
          key: "createdAt",
          scopedSlots: { customRender: "createdAt" },
          sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
        },
        {
          title: this.$t("library.lastUpdate"),
          dataIndex: "updatedAt",
          key: "updatedAt",
          scopedSlots: { customRender: "updatedAt" },
          sorter: (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt),
        },
        {
          title: this.$t("liste.ficheParent"),
          dataIndex: "ficheparent",
          key: "parent",
          scopedSlots: {
            customRender: "ficheparent",
          },
        },
        {
          title: this.$t("liste.inscriSupprimer"),
          dataIndex: "actions",
          scopedSlots: { customRender: "actions" },
          fixed: "right",
        },
      ];
    },
    countGarcon: function () {
      if (this.filtredTable.length === 0) return 0;
      return (
        parseFloat(
          (
            (this.filtredTable.reduce(
              (a, v) => (v.student && v.student.gender === "male" ? a + 1 : a),
              0
            ) *
              100) /
            this.filtredTable.length
          ).toFixed(1)
        ) || 0
      );
    },
    parentsCount: function () {
      const uniqueParentIds = new Set();
      this.filtredTable.forEach((record) => {
        if (record._id) {
          uniqueParentIds.add(record._id);
        }
      });
      return uniqueParentIds.size;
    },
    countFille: function () {
      if (this.filtredTable.length === 0) return 0;
      return (
        parseFloat(
          (
            (this.filtredTable.reduce(
              (a, v) =>
                v.student && v.student.gender === "female" ? a + 1 : a,
              0
            ) *
              100) /
            this.filtredTable.length
          ).toFixed(1)
        ) || 0
      );
    },
  },
  created() {
    this.getPreinscriptionData();
    this.getParentsData();
  },
  methods: {
    moment,
    getPreinscriptionData() {
      this.tableLoading = true;
      apiClient
        .get("/preinscription/")
        .then((res) => {
          this.data = res.data;
          this.filtredTable = this.data;
        })
        .catch((error) => {
          this.$message.error(this.$t("error.fetchingData"));
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getParentsData() {
      apiClient
        .post("/parents/filter", {
          query: { status: "active" },
          aggregation: {
            $project: {
              father: { firstName: 1, lastName: 1, phone: 1 },
              mother: { firstName: 1, lastName: 1, phone: 1 },
              students: 1,
              status: 1,
              financialStatus: 1,
              numberOfChildren: 1,
              adress: 1,
            },
          },
        })
        .then((res) => {
          this.parentsList = res.data;
        })
        .catch((error) => {
          this.$message.error(this.$t("error.fetchingData"));
        });
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },
    updateParent(e) {
      e.preventDefault();
      this.parentsForm.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // --- Phone validation for TN/KE ---
          const phonesToCheck = [
            { value: values.fatherPhone, label: this.$t('liste.telPere') },
            { value: values.motherPhone, label: this.$t('liste.telMere') },
          ];
          for (const entry of phonesToCheck) {
            const phone = (entry.value || "").trim();
            if (!phone) continue;
            const digits = phone.replace(/\D/g, "");
            if (phone.startsWith("+216") && digits.length !== 11) {
              this.$message.error(`${entry.label}: ${this.$t('requis.telephone')}`);
              return;
            }
            if (phone.startsWith("+254") && digits.length !== 13) {
              this.$message.error(`${entry.label}: ${this.$t('requis.telephoneKE')}`);
              return;
            }
          }
          // --- End phone validation ---

          // Check for duplicate phone numbers before updating
          const fatherPhone = values.fatherPhone;
          const motherPhone = values.motherPhone;

          // Check if father's phone number exists
          if (
            fatherPhone &&
            this.checkExistingPhoneNumber(fatherPhone, this.activeParent)
          ) {
            return;
          }

          // Check if mother's phone number exists
          if (
            motherPhone &&
            this.checkExistingPhoneNumber(motherPhone, this.activeParent)
          ) {
            return;
          }

          const id = this.activeParent._id;
          this.loadingData = true;
          const update = {
            father: {
              firstName: values.fatherFirstName,
              middleName: values.fatherMiddleName,
              lastName: values.fatherLastName,
              job: values.fatherJob,
              phone: values.fatherPhone,
              adress: values.fatherAdress,
              email: values.fatherEmail,
              cin: values.fatherCin ? String(values.fatherCin).trim() || undefined : undefined,
            },
            mother: {
              firstName: values.motherFirstName,
              middleName: values.motherMiddleName,
              lastName: values.motherLastName,
              job: values.motherJob,
              phone: values.motherPhone,
              adress: values.motherAdress,
              email: values.motherEmail,
              cin: values.motherCin ? String(values.motherCin).trim() || undefined : undefined,
            },
          };
          apiClient
            .patch(`/preinscription/${id}`, { ...update })
            .then((res) => {
              // Update the data array with the new parent information
              this.data = this.data.map((item) => {
                if (item._id === id) {
                  return {
                    ...item,
                    ...update,
                  };
                }
                return item;
              });
              this.filtredTable = this.data;
              this.visibleParentFile = false;

              // Clear validation timeout
              if (this.phoneValidationTimeout) {
                clearTimeout(this.phoneValidationTimeout);
                this.phoneValidationTimeout = null;
              }

              this.$message.success(this.$t("success.parentMisAJour"));
            })
            .catch(() => {
              this.visibleParentFile = false;
              this.loadingData = false;
              this.$message.warning(this.$t("liste.champsVides"));
            })
            .finally(() => {
              this.loadingData = false;
            });
        }
      });
    },
    parentFile(record) {
      this.componentKey += 1;
      this.activeParent = record;

      console.log(record);

      this.activeStudentlist = this.activeParent.students.map((student) => {
        return {
          title: student.firstName + (student.middleName ? " " + student.middleName : "") + " " + student.lastName,
        };
      });

      this.visibleParentFile = true;

      // Wait for the next tick to ensure the form is rendered before setting values
      this.$nextTick(() => {
        this.parentsForm.setFieldsValue({
          fatherFirstName: record.father?.firstName || "",
          fatherMiddleName: record.father?.middleName || "",
          fatherLastName: record.father?.lastName || "",
          fatherJob: record.father?.job || "",
          fatherPhone: record.father?.phone || "",
          motherFirstName: record.mother?.firstName || "",
          motherMiddleName: record.mother?.middleName || "",
          motherLastName: record.mother?.lastName || "",
          motherJob: record.mother?.job || "",
          motherPhone: record.mother?.phone || "",
          fatherCin: record.father?.cin || "",
          motherCin: record.mother?.cin || "",
          fatherEmail: record.father?.email || "",
          motherEmail: record.mother?.email || "",
          fatherAdress: record.father?.adress || "",
          motherAdress: record.mother?.adress || "",
        });
      });
    },
    async onInscri(record) {
      // --- Phone validation for TN/KE ---
      const phonesToValidate = [
        { value: record.father?.phone, label: this.$t('liste.telPere') },
        { value: record.mother?.phone, label: this.$t('liste.telMere') },
      ];
      for (const entry of phonesToValidate) {
        const phone = (entry.value || "").trim();
        if (!phone) continue;
        const digits = phone.replace(/\D/g, "");
        if (phone.startsWith("+216") && digits.length !== 11) {
          this.$message.error(`${entry.label}: ${this.$t('requis.telephone')}`);
          return;
        }
        if (phone.startsWith("+254") && digits.length !== 13) {
          this.$message.error(`${entry.label}: ${this.$t('requis.telephoneKE')}`);
          return;
        }
      }
      // --- End phone validation ---

      // Check for duplicate phone numbers before inscription (excluding current parent)
      const fatherPhone = record.father?.phone;
      const motherPhone = record.mother?.phone;

      // Check if father's phone number exists
      if (fatherPhone && this.checkExistingPhoneNumber(fatherPhone, record)) {
        return;
      }

      // Check if mother's phone number exists
      if (motherPhone && this.checkExistingPhoneNumber(motherPhone, record)) {
        return;
      }

      // Set loading state for this specific record
      this.$set(record, "inscriptionLoading", true);

      try {
        await apiClient.post(
          `/preinscription/register/${record._id}/${record.student._id}`,
          {
            activeSchoolarYear: this.settings.activeSchoolarYear,
          }
        );

        this.$message.success(this.$t("success.eleveAjout"));
        this.getPreinscriptionData();
      } catch (error) {
        if (error.response?.status === 409) {
          this.$message.warning(this.$t("error.phoneNumberExists"));
        } else {
          this.$message.warning(this.$t("warning.connectionProblem"));
        }
      } finally {
        // Clear loading state
        this.$set(record, "inscriptionLoading", false);
      }
    },
    onDelete(record, notifi = true) {
      apiClient
        .delete(`/preinscription/${record._id}/${record.student._id}`)
        .then((res) => {
          // Remove the record from the data array - filter by both preinscription ID and student ID
          this.data = this.data.filter(
            (item) =>
              !(
                item._id === record._id &&
                item.student._id === record.student._id
              )
          );
          this.filtredTable = this.data;
          if (notifi) this.$message.success(this.$t("success.eleveSupp2"));
        })
        .catch((e) => {
          if (notifi) this.$message.warning(this.$t("error.supp"));
        });
    },
    handleCancelModalParent(e) {
      this.visibleParentFile = false;
      // Clear validation timeout
      if (this.phoneValidationTimeout) {
        clearTimeout(this.phoneValidationTimeout);
        this.phoneValidationTimeout = null;
      }
      // Reset form data when canceling
      this.resetParentForm();
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    resetParentForm() {
      // Reset form fields
      this.parentsForm.resetFields();
    },
    checkExistingPhoneNumber(phoneNumber, data) {
      // Get all existing parents from the API data (excluding current parent)
      const matchingParents = this.parentsList.filter((parent) => {
        const isCurrentParent = parent._id === data.parentID;
        return (
          !isCurrentParent &&
          (parent.father.phone === phoneNumber ||
            parent.mother.phone === phoneNumber)
        );
      });

      if (matchingParents.length > 0) {
        this.$message.warning(
          `${this.$t("error.phoneNumberExists")}: ${phoneNumber}`
        );
        return true; // Return true if duplicate found
      }
      return false; // Return false if no duplicate
    },
    // Add phone number validation methods
    validatePhoneNumber(phoneNumber) {
      if (this.phoneValidationTimeout)
        clearTimeout(this.phoneValidationTimeout);

      if (!phoneNumber || phoneNumber.length < 8) return;

      this.phoneValidationTimeout = setTimeout(() => {
        this.checkExistingPhoneNumber(phoneNumber, this.activeParent);
      }, 700);
    },
    // Handle father phone number change
    onFatherPhoneChange(value) {
      this.validatePhoneNumber(value);
    },
    // Handle mother phone number change
    onMotherPhoneChange(value) {
      this.validatePhoneNumber(value);
    },
  },
};
</script>
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
